export default __webpack_public_path__ + "static/media/grout-tile.280382d4.png";